import { render, staticRenderFns } from "./IsVideo.vue?vue&type=template&id=b481a3c2&"
import script from "./IsVideo.vue?vue&type=script&lang=js&"
export * from "./IsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports